/**
 * Player avatars (shared `types/avatar.ts`). Served art, downloaded with the
 * room's asset package by game types that use avatars. Exhaustive over the
 * avatar ids: a new avatar without art does not compile.
 *
 * The SVGs are drawn inline, not as `<img>`, so CSS can colour them: every shape
 * is painted by a colour-slot class (`pa-skin`, `pa-primary`, …; see
 * served/common/avatars/README.md).
 */
import { artUrl } from './art';
export const PLAYER_AVATAR_ART = {
    'human-a': 'common/avatars/human-a.svg',
    'human-b': 'common/avatars/human-b.svg',
    twilek: 'common/avatars/twilek.svg',
    zabrak: 'common/avatars/zabrak.svg',
    chiss: 'common/avatars/chiss.svg',
    togruta: 'common/avatars/togruta.svg',
    mirialan: 'common/avatars/mirialan.svg',
    cathar: 'common/avatars/cathar.svg',
    rattataki: 'common/avatars/rattataki.svg',
    sith: 'common/avatars/sith.svg',
    miraluka: 'common/avatars/miraluka.svg',
    nautolan: 'common/avatars/nautolan.svg',
    rodian: 'common/avatars/rodian.svg',
    trandoshan: 'common/avatars/trandoshan.svg',
    jedi: 'common/avatars/jedi.svg',
    'sith-hood': 'common/avatars/sith-hood.svg',
    trooper: 'common/avatars/trooper.svg',
    hunter: 'common/avatars/hunter.svg',
    pilot: 'common/avatars/pilot.svg',
    officer: 'common/avatars/officer.svg',
    jawa: 'common/avatars/jawa.svg',
    astromech: 'common/avatars/astromech.svg',
    protocol: 'common/avatars/protocol.svg',
    probe: 'common/avatars/probe.svg',
};
export function getPlayerAvatarUrl(avatarId) {
    return artUrl(PLAYER_AVATAR_ART[avatarId]);
}
